module.exports = __webpack_public_path__ + "img/chronic-bleeding.a87790e0.jpg";